import i18n from "../lang/lang";

// state
const state = {
	locale: 'ru',
	locales: {
		'ru': 'РУ',
		 'uz': 'ЎЗБ',
		 'uz-latn': 'O\'ZB',

		// 'md': 'MO',
	}
};

// getters
const getters = {
	locale: state => state.locale,
	locales: state => state.locales
}

// actions
const actions = {
	setLocale ({ commit }, locale) {
		commit('setLocale', locale);
	}
}

// mutations
const mutations = {
	setLocale (state, locale) {
		state.locale = locale;
		i18n.locale = locale;
		localStorage.setItem('locale', locale);
	}
}

export const locales = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
